<template>
  <div class="form-check-list" :class="props.class">
    <div v-if="props.label != ''">{{props.label}}</div>
    <div class="form-check" v-for="(item, i) in props.options" :key="i">
      <input class="form-check__input" :type="listType" v-model="model" :value="item.id" :id="uniqueId+'_'+item.id" :required="cRequired">
      <label :for="uniqueId+'_'+item.id" class="form-check__label" v-html="item.text"></label>
    </div>
  </div>
</template>

<script setup>
import { computed, watch } from 'vue'
import useUniqueId from '../../../directives/uniqueId';

defineOptions({
  inheritAttrs: false
});

const {uniqueId} = useUniqueId();

const props = defineProps({
  class: {
    type: String,
  },
  label: {
    type: String,
    default: ''
  },
  single: {
    type: Boolean,
    default: false,
  },
  options: {
    type: [Array],
    required: true,
  },
  required: {
    type: Boolean,
    default: false,
  }
});

const listType = computed(()=>{
  return props.single ? 'radio' : 'checkbox';
});

const cRequired = computed(() => {
  if(props.options.length == 1) {
    return props.required;
  }

  return false;
});

const model = defineModel({default:[]});

watch(() => props.options, (n, o) => {
  if(n.length == 0) {
    model.value = model.default;
  }
});


</script>
